import { useTheme } from '@doxyme/ui-foundation/theme';
export const useModalHeaderStyles = ({ isEmpty, hasMultiLineSubtitle })=>{
    const theme = useTheme();
    return {
        container: {
            display: 'flex',
            padding: isEmpty ? theme.spacing(6, 6, 0, 6) : theme.spacing(6),
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: theme.spacing(2),
            alignSelf: 'stretch'
        },
        innerContainer: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: theme.spacing(3),
            alignSelf: 'stretch'
        },
        iconContainer: {
            display: 'flex',
            padding: theme.spacing(1, 0),
            justifyContent: 'center',
            alignItems: 'center',
            gap: 10
        },
        titleContainer: {
            display: 'flex',
            paddingTop: 2,
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: theme.spacing(1),
            flex: '1 0 0'
        },
        title: {
            margin: 0,
            color: theme.text.generic.secondary
        },
        subtitle: {
            display: 'flex',
            alignItems: !hasMultiLineSubtitle ? 'center' : 'flex-end',
            gap: theme.spacing(1),
            alignSelf: 'stretch'
        }
    };
};

//# sourceMappingURL=modalHeader.styles.js.map